import theme from "../../theme";
import type { UserModalStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<UserModalStyles, SxProps<Theme>> => {
  return {
    root: {
      bgcolor: "#fff",
      display: "block",
      maxHeight: "100%",
      height: "100%",
      width: "100%",
      overflow: "scroll",
      pt: theme.spacing(5),
    },

    close: {
      position: "absolute",
      top: 0,
      right: 0,
    },

    paper: {
      mt: theme.spacing(4),
      display: "flex",
      justifyContent: "space-evenly",
      pb: theme.spacing(4),
    },

    selfie: {
      width: "100%",
    },

    document: {
      width: "auto",
      position: "relative",
      overflow: "hidden",
      // maxHeight: "300px",
      // maxWidth: "920px",
      // border: "solid yellow 1px"
      // maxHeight: "500px"
    },

    flipButton: {
      position: "relative",
      // top: 10,
      // right: 10,
    },
  };
};

export default getStyles;
